import { Spacer } from '@telus-uds/components-web'
import { ResponsiveCard } from '../StyledContainers'

import { ModuleTranslationProvider } from '../../../contexts/ModuleTranslation'
import MobilityAccessory from './MobilityAccessory'
import translations from './locales'
import useCart from '../../../hooks/useCart'
import { getAFGroupsWithoutOfferAssociation, getMobilityAccessories, shouldRender } from './utils'
import FinancedAccessoryGroup from '../../molecules/FinancedAccessory/FinancedAccessoryGroup'

const MobilityAccessoryContainer = () => {
  const { cart } = useCart()
  if (!shouldRender(cart)) return null
  const outrightPurchasedMobAccessories = getMobilityAccessories(cart)
  const financedAccessoryGroups = getAFGroupsWithoutOfferAssociation(cart)

  return (
    <ModuleTranslationProvider translations={translations} module="mobility-accessory">
      {financedAccessoryGroups.map((accessoryGroup) => (
        <>
          <ResponsiveCard variant={{ border: 'line', padding: 'custom' }} key={accessoryGroup.id}>
            <FinancedAccessoryGroup
              key={accessoryGroup.id}
              accessoryGroup={accessoryGroup}
              isPurchasedWithPhone={false}
              cart={cart}
            />
          </ResponsiveCard>
          <Spacer space={3} />
        </>
      ))}
      {outrightPurchasedMobAccessories.map((mobAccessory) => (
        <>
          <ResponsiveCard variant={{ border: 'line', padding: 'custom' }} key={mobAccessory.id}>
            <MobilityAccessory
              mobAccessory={mobAccessory}
              isRemoveButtonHidden={false}
              cart={cart}
            />
          </ResponsiveCard>
          <Spacer space={5} />
        </>
      ))}
    </ModuleTranslationProvider>
  )
}

export default MobilityAccessoryContainer
